import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Home.css';

const Home = () =>
{
  const navigate = useNavigate(); 

  const goToProjects = () =>
  {
    navigate('/projects'); 
  };

  return (
    <div className="home-container">
      <div className="left-section">
        <h1>Hallo!</h1>
        <h1>I'm Bun Jak Sin</h1>
      </div>

      <div className="right-section">
        <p className='para'>
          I am an aspiring web developer who is always looking forward to trying new things.
        </p>
        <div className="buttons-container">
          <a href="https://api.whatsapp.com/send?phone=0895369912398" target="_blank" rel="noopener noreferrer">
            <button className="contact-button">Contact Me</button>
          </a>
          <button className="projects-button" onClick={goToProjects}>
            My Projects
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
